module.exports = __webpack_public_path__ + "static/media/downloadcta.40866664.svg";